import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import ProfileShow from './components/profiles/show'

import PostNew from './components/posts/new'
import PostShow from './components/posts/show'
import PostEdit from './components/posts/edit'

const router = new VueRouter({
  routes: [
    { path: '/', component: ProfileShow, name: 'profile.show' },
    { path: '/posts/new', component: PostNew, name: 'post.new' },
    { path: '/posts/:id', component: PostShow, name: 'post.show' },
    { path: '/posts/:id/edit', component: PostEdit, name: 'post.edit' }
  ]
})

export default router
